export default {
  // FrontPage.vue
  frontPageRequirementTitle: 'أحتاج',
  frontPageProvideTitle: 'أعرض',
  frontPagePersonalCenterTitle: 'الملف الشخصي',
  login: 'تسجيل الدخول',
  home_chatWithOctopie: 'جارٍ فهم أفكارك',
  home_chatNeedUnderstood: 'تم فهم أفكارك',
  home_draftBannerTitle: 'أكمل رسالتك',
  home_draftBannerSubtitle: 'الذكاء الاصطناعي جهّز رسالتك — انقر للمتابعة',
  home_tabHome: 'الرئيسية',

  // App.vue
  appRequirementTitle: 'نقدّر كل اقتراح وملاحظة',
  appRequirementBtn: 'إرسال',
  appSubmitSuccess: 'تم الإرسال بنجاح، شكراً لملاحظاتك',
  appFeedbackLink: 'ملاحظات/اقتراحات',
  mobile_banner_text: 'للحصول على أفضل تجربة، استخدم تطبيقنا',
  mobile_banner_btn: 'احصل على التطبيق',

  // Common
  loading: 'جارٍ التحميل...',
  confirm: 'تأكيد',
  cancel: 'إلغاء',
  save: 'حفظ',
  delete: 'حذف',
  edit: 'تعديل',
  add: 'إضافة',
  search: 'بحث',
  refresh: 'تحديث',
  change_batch: 'تبديل',
  back: 'رجوع',
  submit: 'إرسال',
  close: 'إغلاق',
  ok: 'موافق',
  yes: 'نعم',
  no: 'لا',
  send: 'إرسال',
  block: 'حظر',
  more: 'المزيد',
  logout: 'تسجيل الخروج',
  settings: 'الإعدادات',
  view_guide: 'عرض الدليل',
  feedback: 'ملاحظات',
  feedback_title: 'ملاحظات',
  feedback_new: 'ملاحظة جديدة',
  feedback_empty: 'لا توجد ملاحظات بعد',
  feedback_hint: 'أخبرنا برأيك...',
  feedback_submit: 'إرسال',
  feedback_submit_success: 'تم إرسال الملاحظات بنجاح',
  feedback_submit_failed: 'فشل إرسال الملاحظات',
  feedback_reply_label: 'رد المنصة',
  register: 'تسجيل',
  name: 'الاسم',
  email: 'البريد الإلكتروني',
  mobile: 'الجوال',
  password: 'كلمة المرور',
  verification_code: 'رمز التحقق',
  company_name: 'Beijing Liangshao Technology Co., Ltd.',
  all_rights_reserved: 'جميع الحقوق محفوظة.',
  footerVersion: 'الإصدار {version}',
  copy: 'نسخ',
  regenerate: 'إعادة إنشاء',
  generate: 'إنشاء',
  contact_now: 'دردشة',
  yours: 'أنت',
  xiaoyao_analysis: 'تحليل الذكاء الاصطناعي',
  brand_name: 'OctoSay',
  anonymous: 'مجهول',
  no_summary: 'لا يوجد ملخص',
  file: 'ملف',
  discover: 'استكشف',
  discover_title: 'استكشف',
  discover_hotChannels: 'القنوات الشائعة',
  discover_allChannels: 'الكل',
  discover_searchChannel: 'ابحث عن قناة',
  discover_noChannels: 'لا توجد قنوات',

  // Messages
  operationSuccess: 'تمت العملية بنجاح',
  operationFailed: 'فشلت العملية',
  networkError: 'خطأ في الشبكة، حاول مرة أخرى لاحقاً',
  dataLoadingFailed: 'فشل تحميل البيانات',
  noData: 'لا توجد بيانات',
  deleteConfirm: 'هل أنت متأكد من الحذف؟',
  saveConfirm: 'هل أنت متأكد من الحفظ؟',

  // Form Validation
  required: 'هذا الحقل مطلوب',
  emailInvalid: 'يرجى إدخال بريد إلكتروني صالح',
  phoneInvalid: 'يرجى إدخال رقم هاتف صالح',
  passwordTooShort: 'يجب أن تتكون كلمة المرور من {min} أحرف على الأقل',
  passwordMismatch: 'كلمتا المرور غير متطابقتين',

  // Time
  today: 'اليوم',
  yesterday: 'أمس',
  justNow: 'الآن',
  minutesAgo: 'قبل {min} دقيقة',
  hoursAgo: 'قبل {hour} ساعة',
  daysAgo: 'قبل {day} يوم',

  // Footer
  about: 'عن التطبيق',
  footerPrivacy: 'سياسة الخصوصية',
  footerTerms: 'شروط الخدمة',
  footerSupport: 'الدعم والمساعدة',

  // Register
  registerAgeConfirm: 'أؤكد أن عمري 13 عاماً على الأقل',
  registerAgeConfirm18: 'أؤكد أن عمري 18 سنة على الأقل',
  registerTermsPrefix: 'لقد قرأت وأوافق على ',
  registerTermsAnd: ' و',
  registerAgeError: 'يرجى تأكيد عمرك',
  registerTermsError: 'يرجى الموافقة على الشروط وسياسة الخصوصية',

  // Chat
  chatPrivacyTip: 'اكتب رسالتك في الـhub وسيختبر الذكاء الاصطناعي معك أولاً لتوضيح التفاصيل. بعد التأكيد، تُنشر رسالتك وملخص الذكاء الاصطناعي معاً ويستمر AI في البحث عن المطابقات.',
  aiChat_quickSuggestions: 'جرّب أن تقول',
  aiChat_welcome: "مرحباً! أخبرني بما تبحث عنه.",

  // Chat - AI Progress Steps (new)
  aiChat_readyToPost: 'فُهمت التفاصيل — انشر للعثور على مطابقتك',
  aiChat_readyToPostHint: 'تابع المحادثة لإضافة تفاصيل أو تحديث الملخص في أي وقت',
  aiChat_progressStep1: 'فهم التفاصيل',
  aiChat_progressStep1Done: 'فُهمت التفاصيل',
  aiChat_progressStep2: 'ملخص الذكاء الاصطناعي',
  aiChat_progressStep2Desc: "ينشئ AI ملخصاً للتوافق",
  aiChat_progressStep3: 'انشر في المجموعة',
  aiChat_progressStep3Desc: 'انشر وابحث عن مطابقتك',
  aiChat_publishExtraHint: 'أدخل رسالتك إلى الـhub',
  aiChat_publishMsgRequired: 'مطلوب',
  aiChat_publishMsgLabel: 'رسالتك إلى الـhub',
  aiChat_matchSummaryLabel: 'ملخص الذكاء الاصطناعي',

  ai_generated_label: 'AI Generated',

  ai_content_disclaimer: 'المحتوى التالي مُنشأ بواسطة الذكاء الاصطناعي وللرجوع إليه فقط.',
  aiChat_publishSuggestionHint: 'انقر للاستبدال',
  aiChat_allowDirectContact: 'السماح بالتواصل المباشر',
  aiChat_allowDirectContactDesc: 'يمكن للآخرين التواصل معك مباشرة دون مطابقة',
  channel_chat_session_publishToChannel: 'انشر في مجموعة Octo',
  aiChat_newChat: 'إعادة تعيين',

  // Channels / مجموعات
  home_tabChannels: 'مجموعات Octo',
  channels_title: 'مجموعات Octo',
  channels_myChannels: 'المجموعات المنضم إليها',
  channels_discover: 'استكشف',
  channels_noChannels: 'لا توجد مجموعات بعد',
  channels_noMyGroupsTitle: 'لم تنضم إلى أي مجموعة بعد',
  channels_noMyGroupsSubtitle: 'ابحث عن مجموعة للانضمام وابدأ التواصل',
  channels_searchGroupsBtn: 'ابحث عن مجموعات',
  channels_loginPrompt: 'يرجى تسجيل الدخول لعرض الـhubs',
  channels_create: 'أنشئ مجموعة Octo',
  channels_search: 'ابحث عن مجموعة Octo',
  channels_searchMyGroups: 'ابحث في مجموعات Octo الخاصة بي',
  channels_searchHint: 'بحث',
  channels_searchHintChats: 'ابحث في المحادثات...',
  channels_searchHintGroups: 'ابحث عن مجموعات...',
  channels_searchHintMy: 'ابحث في الـhubs المنضم إليها...',
  channels_joinByCode: 'الانضمام بالرمز',
  channels_joinByCodeTitle: 'انضم إلى مجموعة Octo بالرمز',
  channels_joinByCodeHint: 'أدخل رمز مجموعة Octo',
  channels_joinByCodeConfirm: 'انضم',
  channels_joinByCodeNotFound: 'لم يتم العثور على الـhub',
  channels_createNewGroup: 'أنشئ مجموعة Octo جديداً',
  channels_noResults: 'لم يتم العثور على مجموعات',
  channel_detail_join: 'انضم',
  channel_detail_leave: 'غادر',
  channel_detail_members: 'أعضاء',
  // 聚合进群消息 banner（joinMsgs）
  channelJoinMsg_oneJoined: '{name} انضم إلى المجموعة',
  channelJoinMsg_twoJoined: '{name1} و{name2} انضما إلى المجموعة',
  channelJoinMsg_multiJoined: '{name1} و{name2} و{n} آخرين انضموا إلى المجموعة',
  channelJoinMsg_oneAndMoreJoined: '{name} و{n} آخرين انضموا إلى المجموعة',
  channelJoinMsg_membersJoined: 'انضم {n} أعضاء إلى المجموعة',

  // Feed
  channels_feed: 'المحادثات',
  channels_groups: 'المجموعات',
  feed_related: 'ذات صلة',
  feed_recommend: 'مقترح',
  feed_empty: 'لا يوجد محتوى بعد، استكشف الـhubs الشائعة',
  feed_goToGroup: 'عرض في الـhub',
  feed_joinGroupAndSendMsg: 'انضم إلى مجموعة وأرسل رسالة',
  channel_detail_channelCode: 'رمز مجموعة Octo',
  channel_detail_invitePhrase: 'دعوة للانضمام إلى "{name}"\nكود الدعوة {code} — افتح التطبيق للانضمام تلقائيًا · الذكاء الاصطناعي يوضح التفاصيل أولاً ثم يجد لك الأشخاص المناسبين',
  channel_detail_post: 'انشر في المجموعة',
  channel_detail_aiHint: "اكتب رسالتك في المجتمع وسيوضح AI التفاصيل أولاً",
  channel_input_hint: 'قل شيئاً...',
  channel_leave_confirm_message: 'هل أنت متأكد من مغادرة هذا الـhub؟ لن تتلقى رسائل الـhub بعد الآن.',
  channel_invite_notFound: 'الـhub غير موجود أو انتهت صلاحية الرابط',
  channel_invite_joinBtn: 'حمّل تطبيق OctoSay',
  channel_invite_hint: 'حمّل التطبيق، ثم امسح رمز QR هذا أو ابحث عن اسم الـhub للانضمام',
  channel_invite_globalHintTitle: 'أنت على وشك تنزيل النسخة العالمية',
  channel_invite_globalHintIOS: 'قد لا يكون هذا التطبيق متاحاً في App Store الصيني. يرجى التبديل إلى متجر Apple خارج الصين والبحث عن OctoSay، أو نزّل ملف APK مباشرة من الأسفل.',
  channel_invite_globalHintAndroid: 'قد لا يكون Google Play متاحاً في منطقتك. نوصي بتنزيل ملف APK مباشرة، أو جرّب Google Play.',
  channel_invite_globalHintDefault: 'قد لا يكون التطبيق متاحاً في متجر تطبيقاتك المحلي. نوصي بتنزيل ملف APK مباشرة، أو جرّب App Store.',
  channel_invite_globalBtnAppStore: 'اذهب إلى App Store',
  channel_invite_globalBtnGooglePlay: 'اذهب إلى Google Play',
  channel_invite_globalBtnAPK: 'نزّل APK مباشرة',
  channel_invite_defaultDesc: 'انضم إلى {name} على OctoSay',
  share: 'مشاركة',
  share_channel: 'شارك المجموعة',
  share_channel_link: 'مشاركة الرابط',
  channel_detail_inviteCode: 'رمز الدعوة',
  channel_detail_copyLink: 'نسخ الرابط',
  share_session_title: 'منشور على OctoSay',
  share_match_title: 'مطابقة على OctoSay',
  share_session_text: '{userName}: {summary}',
  share_session_text_no_summary: 'اطلع على ما نشره {userName} على OctoSay',
  session_share_notFound: 'المنشور غير موجود أو انتهت صلاحية الرابط',
  session_share_fromChannel: 'من مجموعة Octo',
  session_share_downloadBtn: 'حمّل تطبيق OctoSay',
  session_share_hint: 'حمّل التطبيق لعرض المنشور الكامل والانضمام إلى الـhub',
  session_share_openInApp: 'افتح في التطبيق',
  toast_link_copied: 'تم نسخ الرابط',
  toast_no_share_data: 'لا يوجد ما يمكن مشاركته',
  channels_joinByQR: 'رمز QR',
  channels_joinByQRWebHint: 'الويب لا يدعم مسح رموز QR. يرجى إدخال رمز الـhub للانضمام.',
  channels_joinByQRTitle: 'الانضمام برمز QR',
  channel_detail_qrCode: 'رمز QR',
  channel_detail_qrCodeSave: 'حفظ الصورة',
  channel_detail_qrCodeSaveHint: 'انقر بزر الفأرة الأيمن على الصورة لحفظها',
  channel_detail_qrCodeSaved: 'تم الحفظ في الألبوم',
  channel_detail_qrCodeSaveFailed: 'فشل الحفظ، حاول مرة أخرى',
  channel_detail_locateFailed: 'فشل تحديد موقع الرسالة',
  channel_detail_locateError: 'خطأ في تحديد موقع الرسالة',
  channel_detail_myMessages: 'رسائلي',
  channel_detail_searchMessages: 'ابحث في الرسائل',
  channel_detail_aiChat: 'دردشة AI',
  channel_detail_matchHistory: 'سجل المطابقات',
  channel_create_title: 'أنشئ مجموعة Octo',
  channel_create_name: 'اسم مجموعة Octo',
  channel_create_description: 'الوصف',
  channel_create_submit: 'إنشاء',
  channelCreate_aiAssist: 'سيساعدك AI في إنشاء مجموعة مناسب',
  channelCreate_nameHint: 'أدخل اسماً لـhub الخاص بك',
  channelCreate_descHint: 'صف موضوع الـhub الخاص بك',
  channelCreate_creating: 'جارٍ الإنشاء...',
  channelCreate_created: 'تم إنشاء الـhub!',
  channelCreate_failed: 'فشل إنشاء الـhub',
  channelCreate_welcomeMsg: "مرحباً! أنا هنا لمساعدتك في إنشاء مجتمع. أخبرني بما تريد — اسمه أو موضوعه أو غرضه — وسأحوله إلى اسم مجتمع ومقدمة، وأولّد الصورة الرمزية.",
  channelCreate_aiHint: 'اكتب موضوع الـhub الخاص بك...',
  channelCreate_clarifyingProgress: 'جارٍ تنظيم موضوع الـhub الخاص بك...',
  channelCreate_readyToCreate: 'جاهز لإنشاء مجموعة Octo',
  channelCreate_step1: 'صف الموضوع',
  channelCreate_step1Done: 'وُضحت الفكرة',
  channelCreate_step2: 'أنشئ مجموعة Octo',
  channelCreate_confirmBtn: 'تأكيد الإنشاء',
  channelCreate_publicNotice: "المجتمعات مساحات عامة يجتمع فيها أصحاب الاهتمامات المشتركة ويتواصلون. قد تقوم المنصة بإدارة المجتمعات أو تحديثها أو دمجها حسب الحاجة. لا تتردد في مشاركة هذا المجتمع مع الآخرين المهتمين.",
  channelCreate_similarGroupsTitle: 'تم العثور على مجموعات Octo مشابهة',
  channelCreate_similarGroupsDesc: 'قد تتوافق هذه الـhubs مع ما تريد',
  channelCreate_exactMatchHint: 'يوجد بالفعل مجموعة بهذا الاسم تماماً!',
  channelCreate_joinHint: 'قد تكون هذه المجموعات الحالية مناسبة لك',
  channelCreate_joinExisting: 'انضم إلى مجموعة Octo موجود',
  channelCreate_stillCreate: 'أنشئ مجموعة Octo جديداً رغم ذلك',
  channel_chat_session_comments: 'التعليقات',
  channel_chat_session_commentHint: 'اكتب تعليقاً...',
  channel_chat_session_sendComment: 'تعليق',
  channel_chat_session_loadMore: 'عرض المزيد',
  channel_chat_session_noComments: 'لا توجد تعليقات بعد',
  channel_chat_session_deleteComment: 'حذف',
  channelSearch_title: 'البحث في المجموعة',
  channelSearch_placeholder: 'ابحث في الرسائل...',
  channelSearch_onlyMine: 'منشوراتي فقط',
  channelSearch_tabAllMessages: 'رسائل المجموعة',
  channelSearch_tabMyMessages: 'رسائلي',
  chatMsgSearch_placeholder: 'ابحث في الرسائل',
  chatMsgSearch_tabMsgs: 'الرسائل',
  chatMsgSearch_tabContacts: 'جهات الاتصال',
  chatMsgSearch_emptyPrompt: 'اكتب كلمات مفتاحية للبحث في الرسائل',
  chatMsgSearch_tooShort: 'اكتب حرفين على الأقل للبحث',
  chatMsgSearch_contactEmptyPrompt: 'اكتب اسم مستخدم أو بريداً إلكترونياً للبحث في جهات الاتصال',
  chatMsgSearch_noContacts: 'لا توجد جهات اتصال مطابقة',
  chatMsgSearch_inChatPlaceholder: 'ابحث في هذه المحادثة',
  channelHistory_title: 'السجل',
  channelHistory_myMessages: 'رسائلي',
  channelHistory_loadMore: 'عرض المزيد',
  channel_settings_push: 'إشعارات مجموعة Octo',
  channel_settings_commentPush: 'إشعارات التعليقات',
  channel_settings_likePush: 'إشعارات الإعجاب',
  channel_settings_receiveNotifications: 'تلقي الإشعارات',
  channel_settings_directContact: 'السماح بالتواصل المباشر',
  session_published: 'منشور',
  session_publishFailed: 'فشل النشر',
  session_setDirectContactSuccess: 'تم حفظ الإعداد',
  session_setDirectContactFailed: 'فشل حفظ الإعداد',
  session_setPrivate: 'اجعله خاصاً',
  session_setPublic: 'اجعله عاماً',
  session_pauseMatching: 'إيقاف المطابقة مؤقتًا',
  session_resumeMatching: 'استئناف المطابقة',
  session_matchPausedToast: 'تم إيقاف المطابقة مؤقتًا',
  session_matchResumedToast: 'تم استئناف المطابقة',
  match_matchingPausedTitle: 'المطابقة متوقفة مؤقتًا',
  match_reasonTag: 'سبب المطابقة',
  match_matchingPausedHint: 'يمكنك استئناف المطابقة في أي وقت.',
  session_confirmSetPrivate: 'جعل هذا المحتوى خاصاً؟ لن يتمكن المستخدمون الآخرون من مشاهدته.',
  session_messageIsPrivate: 'هذه الرسالة خاصة',
  chatSessionComment_replyHint: 'اكتب تعليقاً...',
  chatSessionComment_reply: 'تعليق',
  // 阿拉伯语 6 段复数（zero/one/two/few/many/other），配合 index.js 的 pluralizationRules
  chatSessionComment_count: '{n} تعليقات | {n} تعليق | {n} تعليقان | {n} تعليقات | {n} تعليق | {n} تعليق',
  chatSessionMatch_count: '{n} توافقات | {n} توافق | {n} توافقان | {n} توافقات | {n} توافق | {n} توافق',
  chatSessionComment_replyTo: 'رد',
  chatSessionComment_inputHint: 'اكتب تعليقاً...',
  chatSessionComment_send: 'إرسال',
  chatSessionComment_delete: 'حذف',
  chatSessionComment_deleteConfirm: 'هل أنت متأكد من حذف هذا التعليق؟',
  chatSessionComment_loadMore: 'عرض المزيد',
  chatSessionComment_noMore: 'لا مزيد من التعليقات',
  chatSessionComment_loginToComment: 'يرجى تسجيل الدخول للتعليق',
  chatSessionComment_viewEarlier: 'عرض الردود السابقة ({n})',
  chatSessionLike_like: 'إعجاب',
  chatSessionLike_liked: 'أعجبني',
  chatSessionLike_count: 'إعجاب',
  chatSessionBookmark_bookmark: 'حفظ',
  chatSessionBookmark_bookmarked: 'محفوظ',
  chatSessionMatch_viewMatches: 'عرض المطابقات',
  chatSessionMatch_matchHistory: 'سجل المطابقات',
  chatSessionMatch_noMatches: 'لا توجد مطابقات بعد',
  channel_match_achievement: 'تمت مطابقة {count} منشوراً بنجاح',
  channel_match_achievement_view: 'عرض →',
  channel_matchHistory_title: 'سجل مطابقات القناة',
  chatSessionMatch_matchedAt: 'تمت المطابقة في {time}',
  discover_userMsgLabel: 'قال المستخدم',
  common_loading: 'جارٍ التحميل...',
  common_sending: 'جارٍ الإرسال...',
  common_error: 'خطأ',
  common_success: 'نجاح',
  common_me: 'أنا',

  // Chat - Set Public / Pick Location
  aiChat_clarifyingProgress: "يقوم الذكاء الاصطناعي بتوضيح طلبك لضمان أن كل رسالة تنشرها فعّالة؛ وبعد النشر سيواصل إيجاد التوافقات لك",
  aiChat_clarifyingAlmostDone: 'كدناك تنتهي، يرجى التأكيد',
  aiChat_clarifyingOneMore: 'يبقى سؤال واحد تقريباً، ثم يمكنك النشر',
  aiChat_clarifyingRemaining: 'تبقى حوالي {count} جولات، كدناك ننتهي',
  aiChat_clarifyingEvaluating: 'جارٍ تقييم التقدم...',
  aiChat_setPublicMatch: 'اجعله عاماً وطابِق',
  aiChat_needsClarifiedPublic: "فهمتك الآن. بمجرد تأكيدك والنشر، سيواصل AI البحث عن التوافقات لك.\nلا تتردد في مشاركة المزيد من التفاصيل في أي وقت.",
  aiChat_needsClarifiedPrivate: 'فهمت! اجعله عاماً ودعني أستمر في إيجاد المطابقات!\nأخبرني بمزيد من التفاصيل في أي وقت.',
  aiChat_setPublicTitle: 'اجعله عاماً',
  aiChat_setPublicMessage: 'سيكون محتواك مرئياً للآخرين ليتمكن OctoSay من العثور على مطابقات مناسبة لك.\n\nالمعلومات التي ستُشارك:\n• اسم المستخدم وصورتك الشخصية\n• ملخص محتواك\n• محتوى المحادثة (مرئي في الاستكشاف)\n\nيمكنك إعادته إلى الخاص في أي وقت.',
  aiChat_findMatches: 'عرض نتيجة المطابقة',
  aiChat_publishing: 'جارٍ النشر...',
  aiChat_matchSectionTitle: 'رسالتك تناسب هذه المجموعات أكثر — اضغط للنشر',
  aiChat_joinedBadge: 'منضم',
  aiChat_matchSectionEmpty: 'لا توجد مجتمعات مطابقة بشكل جيد بعد — يمكنك إنشاء مجتمع جديد والنشر فيه',
  aiChat_suggestPublishCreateNew: 'أنشئ مجتمعاً جديداً',
  aiChat_repickChannel: 'تغيير المجموعة',
  aiChat_creatingChannelTitle: 'لا يوجد مجتمع مناسب — جارٍ إنشاء واحد لك',
  aiChat_creatingChannelHint: 'ينشئ الذكاء الاصطناعي مجتمعًا وفق طلبك ثم تنتقل مباشرة إلى النشر — يستغرق عادةً من 10 إلى 30 ثانية',
  aiChat_publishToChannelHint: 'سيتم النشر في "{name}"',
  aiChat_pickChannelTitle: 'اختر مجتمعًا للنشر',
  aiChat_matchingChannelTitle: 'جارٍ البحث عن المجتمع المناسب لك',
  aiChat_matchingChannelHint: 'تبحث الذكاء الاصطناعي بناءً على طلبك — عادةً من ثوانٍ إلى نصف دقيقة',
  aiChat_matchUnavailableTitle: 'التوصيات غير متاحة حاليًا',
  aiChat_matchUnavailableHint: 'ابحث عن مجتمع بالأسفل أو أغلق ثم أعد فتح النشر',
  aiChat_waitSlowHint: 'يستغرق وقتًا أطول من المعتاد لكن المعالجة مستمرة — انتظر قليلاً أو ابحث عن مجتمع بالأسفل',
  aiChat_creatingSlowHint: 'يستغرق إنشاء المجتمع وقتًا أطول من المعتاد لكن المعالجة مستمرة — بعد ذلك تنتقل مباشرة إلى النشر',
  aiChat_pickChannelEmptyHint: 'لم نجد مجتمعات ذات صلة. أنشئ مجتمعاً جديداً وانشر رسالتك',
  aiChat_loadMore: 'تحميل المزيد',
  sidebar_publish: 'نشر',
  chat_selectLocationOnMap: 'يرجى تحديد موقع على الخريطة',

  // App.vue new
  placeholder_email: 'يرجى إدخال البريد الإلكتروني',
  placeholder_mobile: 'يرجى إدخال رقم الجوال',
  placeholder_password: 'يرجى إدخال كلمة المرور',
  placeholder_name: 'يرجى إدخال اسمك',
  random_nickname: 'عشوائي',
  placeholder_verification_code: 'يرجى إدخال رمز التحقق',
  sending: 'جارٍ الإرسال...',
  registering: 'جارٍ التسجيل...',
  send_code: 'إرسال الرمز',
  retry_in_seconds: 'إعادة المحاولة خلال {countdown} ثانية',
  toast_enter_email: 'يرجى إدخال البريد الإلكتروني',
  toast_enter_mobile: 'يرجى إدخال رقم الجوال',
  toast_invalid_email: 'يرجى إدخال صيغة بريد إلكتروني صالحة',
  toast_invalid_mobile: 'يرجى إدخال رقم جوال صالح',
  toast_send_code_failed: 'فشل إرسال رمز التحقق',
  toast_code_sent: 'أُرسل رمز التحقق إلى البريد الإلكتروني',
  toast_code_sent_sms: 'أُرسل رمز التحقق إلى الجوال',
  toast_send_code_error: 'فشل إرسال رمز التحقق، حاول مرة أخرى لاحقاً',
  toast_fill_all_fields: 'يرجى تعبئة جميع الحقول',
  toast_login_failed: 'فشل تسجيل الدخول',
  toast_login_success: 'تم تسجيل الدخول بنجاح',
  oauthOr: 'أو',
  toast_oauth_login_failed: 'فشل تسجيل الدخول عبر Google',
  toast_oauth_login_error: 'خطأ في تسجيل الدخول عبر Google، حاول مرة أخرى',
  toast_login_error: 'فشل تسجيل الدخول، حاول مرة أخرى لاحقاً',
  toast_register_failed: 'فشل التسجيل',
  toast_register_success: 'تم التسجيل بنجاح',
  toast_register_error: 'فشل التسجيل، حاول مرة أخرى لاحقاً',

  // AdBanner.vue
  ad: 'إعلان',

  // ContactAdGate.vue 联系前广告闸门
  contactAd_gateTitle: 'قبل التواصل',
  contactAd_gateSubtitle: 'هذه الوقفة القصيرة تُبقي OctoSay مجانيًا — شكرًا لدعمك!',
  contactAd_waitBtn: 'يمكنك المتابعة بعد {sec} ثانية',
  contactAd_continueBtn: 'المتابعة إلى الدردشة',

  // ChannelDetail.vue 私聊按钮
  session_privateChat: 'دردشة',

  // AiMatch.vue
  ai_welcome_msg: 'مرحباً، أنا AI. أخبرني بما يدور في ذهنك — رفيق، شريك، تبادل مهارات، أو أي شيء.',
  default_username: 'مستخدم',

  // AvatarCropDialog.vue
  crop_hint: 'اضغط بإصبعين للتكبير، اسحب للتعديل',
  toast_crop_failed: 'فشل اقتطاع الصورة',

  // ChatBox.vue
  loading_match_info: 'جارٍ تحميل معلومات المطابقة...',
  view_match_details: 'عرض تفاصيل المطابقة',
  step_clarify_needs: 'توضيح',
  step_ai_matching: 'انشر في المجموعة',
  step_connect: 'مطابقة بالذكاء الاصطناعي',
  make_private: 'اجعله خاصاً',
  setting: 'جارٍ الإعداد...',
  action_photo: 'صورة',
  action_file: 'ملف',
  action_video: 'فيديو',
  action_location: 'الموقع',
  hint_get_app: 'احصل على التطبيق لتبقى على اتصال',
  match_finding_title: 'مطابقاتك',
  match_finding_subtitle: 'يستمر AI في البحث عن مطابقات لك',
  match_time_hint: 'تستغرق هذه العملية عادة من دقيقة إلى دقيقتين',
  match_result_stats: 'تم العثور على {matched} من أفضل التوافقات{interested}',
  match_tap_to_connect: 'انقر لبدء محادثتك',
  match_channel_hint: 'جارٍ المطابقة في الـhub <strong>#{channel}</strong>. نعطي الأولوية لمطابقات نفس الـhub، ولكن قد تشمل مجموعات أخرى عند الحاجة.',
  label_perfect_match: 'أفضل مطابقة',
  label_worth_a_look: 'جديرة بالاطلاع',
  match_no_result_title: 'ما زلنا نبحث عن مطابقة لك',
  match_no_result_desc: 'شارك المزيد من التفاصيل لمساعدة OctoSay على إيجاد المطابقات المناسبة. ثبّت التطبيق لتلقي الإشعارات عند مطابقة شخص لك.',
  go_back: 'رجوع',
  no_public_requirements: 'لا توجد منشورات عامة بعد',
  channelEmpty_title: 'لا يزال الهدوء هنا',
  channelEmpty_subtitle: 'كن أول من يشارك أفكاره',
  channelEmpty_hint: "اكتب أفكارك وسييساعدك AI في توضيحها، ويواصل البحث عن التوافقات، حتى لا تضيع رسالتك",
  channelEmpty_action: 'شارك أفكارك',
  stay_connected: 'ابقَ على اتصال',
  download_app_desc: 'احصل على التطبيق للدردشة وتلقي الإشعارات فوراً عند تواصل أحدهم معك!',
  app_store: 'App Store',
  google_play: 'Google Play',
  direct_apk: 'APK مباشر',
  match_history: 'سجل المطابقات',
  no_match_history: 'لا يوجد سجل مطابقات بعد',
  finding_matches: 'يستمر AI في إيجاد مطابقات لك - بعد نشر رسالة في مجموعة',
  discover_connect_hint: 'يمكنك الدردشة معهم عند حدوث المطابقة!',
  match_initializing: 'جارٍ التهيئة...',
  placeholder_login_to_chat: 'سجّل الدخول لتخبرني بما يدور في ذهنك',
  toast_need_clear: 'وضحت فكرتك!',
  toast_ai_responding: 'يجيب AI الآن، يرجى الانتظار...',
  toast_uploading_image: 'جارٍ رفع الصورة، يرجى الانتظار...',
  toast_uploading_file: 'جارٍ رفع الملف، يرجى الانتظار...',
  toast_max_photos: 'الحد الأقصى {max} صور',
  toast_uploading: 'جارٍ الرفع، يرجى الانتظار...',
  toast_file_too_large: '{name} يتجاوز حد 5MB',
  toast_video_too_large: '{name} يتجاوز حد 20MB',
  toast_video_processing: 'جارٍ معالجة الفيديو، يرجى الانتظار...',
  toast_upload_link_failed: 'فشل الحصول على رابط الرفع',
  analyzing_image: 'جارٍ تحليل الصورة...',
  toast_location_confirmed: 'تم تأكيد الموقع',
  toast_location_selected: 'تم اختيار الموقع',
  toast_enter_search: 'يرجى إدخال محتوى البحث',
  toast_search_failed: 'فشل البحث',
  toast_no_locations: 'لم يتم العثور على مواقع',
  toast_search_error: 'فشل البحث، حاول مرة أخرى',
  toast_located_at: 'الموقع: {address}',
  toast_shared_finding: 'تمت المشاركة! جارٍ البحث عن مطابقات...',
  toast_update_failed: 'فشل التحديث',
  toast_set_private: 'تم جعله خاصاً',
  toast_no_matches: 'لم يتم العثور على مطابقات',
  toast_matches_found: 'تم العثور على {count} من أفضل التوافقات',
  toast_start_conversation_first: 'ابدأ محادثة أولاً',
  toast_load_history_failed: 'فشل تحميل سجل المطابقات',
  toast_ai_timeout: 'انتهت مهلة استجابة AI، حاول مرة أخرى',
  toast_message_blocked: 'تم حظر الرسالة',
  network_disconnected: 'انقطع الاتصال بالشبكة',
  toast_publish_success: 'نُشر في الـhub!',
  toast_publish_failed: 'فشل النشر في الـhub',

  // ChatMsgList.vue
  collapse_thinking: 'إخفاء عملية التفكير',
  expand_thinking: 'إظهار عملية التفكير',
  thinking: 'يفكر',
  select_date: 'اختر التاريخ',
  selected_location: 'الموقع المحدد',
  msg_blocked: 'محظور',
  retry: 'إعادة المحاولة',
  msg_read: 'مقروء',
  msg_sent: 'مُرسل',
  msg_unread: 'غير مقروء',
  label_start_datetime: 'تاريخ ووقت البدء:',
  label_end_datetime: 'تاريخ ووقت الانتهاء:',
  toast_select_start_datetime: 'يرجى اختيار تاريخ ووقت البدء',
  toast_end_before_start: 'لا يمكن أن يكون وقت الانتهاء قبل وقت البدء',
  report_message: 'الإبلاغ عن الرسالة',
  block_user: 'حظر المستخدم',
  msg_revoke: 'استرجاع',
  msg_quote: 'اقتباس',
  msg_revoked_self: 'لقد استرجعت رسالة',
  msg_revoked_other: 'استرجع الطرف الآخر رسالة',
  // Neutral text inside quote block: the revoker is the sender of the quoted message, unrelated to current message direction
  msg_revoked_generic: 'تم استرجاع الرسالة',
  // Platform removal (content moderation manual review), distinct from self-revoke
  msg_revoked_platform: 'أُزيلت هذه الرسالة من قبل المنصة بسبب مخالفة القواعد',
  msg_blocked_label: 'This message was blocked by the platform',
  toast_revoke_success: 'تم استرجاع الرسالة',
  toast_revoke_failed: 'فشل استرجاع الرسالة',
  toast_load_data_failed: 'فشل تحميل البيانات، يرجى التحديث.',
  toast_file_url_missing: 'رابط الملف غير موجود',
  toast_block_success: 'تم حظر المستخدم بنجاح',
  toast_block_failed: 'فشل حظر المستخدم',

  // ChatSession.vue
  no_more_records: 'لا مزيد من السجلات.',
  title_needs_clarified: 'وُضحت الأفكار',
  title_clarifying: 'جارٍ توضيح أفكارك',
  title_public: 'عام',
  title_private: 'خاص',
  badge_clarified: 'موضح',
  badge_clarifying: 'قيد التوضيح',
  badge_only_me: 'أنا فقط',
  badge_expired: 'منتهي',
  title_expired: 'منتهي',
  no_chat_history: 'لا يوجد سجل محادثات',

  // ContactMethods.vue
  block_status_banner: 'لقد حظرت هذا المستخدم',
  unblock_user: 'إلغاء الحظر',
  toast_block_missing_id: 'لا يمكن الحظر: معرف المستخدم مفقود',
  dialog_block_confirm: 'هل أنت متأكد من حظر {name}؟ لن تتلقى أي رسائل منه.',
  toast_user_blocked: 'تم حظر {name}',
  toast_unblock_missing_id: 'لا يمكن إلغاء الحظر: معرف المستخدم مفقود',
  toast_user_unblocked: 'تم إلغاء حظر {name}',

  // BlockedUsers.vue
  blocked_users: 'المستخدمون المحظورون',
  blocked_users_empty: 'لا يوجد مستخدمون محظورون',
  blocked_users_empty_hint: 'لن يتمكن المستخدمون المحظورون من إرسال رسائل إليك',
  blocked_users_unblock: 'إلغاء الحظر',
  dialog_unblock_confirm: 'بعد إلغاء الحظر، سيتمكن من إرسال رسائل إليك مرة أخرى.',
  toast_unblock_success: 'تم إلغاء الحظر',
  toast_unblock_failed: 'فشل إلغاء الحظر، حاول مرة أخرى',
  blocked_users_load_failed: 'فشل التحميل. انقر لإعادة المحاولة',
  blocked_users_blocked_at: 'محظور {date}',
  blocked_users_unknown_user: 'مستخدم غير معروف',

  // Contacts.vue
  no_connections: 'لا توجد رسائل بعد',
  chat_with: 'دردشة مع {name}',
  toast_load_contacts_failed: 'فشل تحميل جهات الاتصال: {msg}',
  toast_load_contacts_error: 'فشل تحميل جهات الاتصال. يرجى التحديث والمحاولة مرة أخرى.',
  time_just_now: 'الآن',
  time_minutes_ago: 'قبل {min}د',
  time_hours_ago: 'قبل {hour}س',
  time_days_ago: 'قبل {day}ي',

  // InteractionNotification.vue
  interaction_notification_title: 'الإشعارات',
  interaction_notification_subtitle: 'التعليقات والإعجابات',
  interaction_notification_empty: 'لا توجد إشعارات بعد',
  interaction_notification_comment: 'علّق: {content}',
  interaction_notification_like: 'أعجب بمنشورك',
  interaction_notification_reply: 'ردّ: {content}',
  interaction_notification_bookmark: 'حفظ منشورك',
  toast_load_notifications_failed: 'فشل تحميل الإشعارات: {msg}',
  toast_load_notifications_error: 'فشل تحميل الإشعارات. يرجى التحديث والمحاولة مرة أخرى.',
  mark_all_read: 'وضع علامة مقروء على الكل',
  toast_mark_all_read_failed: 'فشلت العملية، حاول مرة أخرى',
  contacts_dnd: 'كتم الإشعارات',
  dnd_enabled: 'تم كتم الإشعارات',
  dnd_disabled: 'تم إلغاء كتم الإشعارات',
  dnd_action_enable: 'كتم الإشعارات',
  dnd_action_disable: 'إلغاء كتم الإشعارات',

  // Discover.vue
  toast_load_sessions_failed: 'فشل تحميل الجلسات: {msg}',
  toast_load_sessions_error: 'فشل تحميل الجلسات',
  discover_noMessages: 'لا توجد رسائل بعد',

  // EmojiInputArea.vue
  placeholder_default: 'شارك المزيد من التفاصيل مع AI',
  userChat_typeMessage: 'اكتب رسالة...',
  select_emoji: 'اختر رمزاً تعبيرياً',
  badge_new: 'جديد',
  channel_search_placeholder: 'أدخل القناة',
  channel_picker_empty: 'أدخل القناة',

  // FrontPage.vue
  tab_chat_with_ai: 'دع OctoSay يفهمك',
  history_chats: 'السجل',
  tab_connections: 'التوافقات',
  tab_conversations: 'الرسائل',
  tab_profile: 'الملف الشخصي',
  new_session: 'جديد',
  history_tab_chats: 'لي',
  history_tab_matches: 'التوافقات',
  channels_octosay: 'مجموعات Octo',
  tab_matches: 'التوافقات',
  tab_messages: 'الرسائل',

  // Header.vue
  slogan: 'OctoSay - الذكاء الاصطناعي الذي يفهمك ويوصلك بالشخص المناسب',
  app_name: 'OctoSay',
  slogan_short: 'الذكاء الاصطناعي الذي يفهمك ويوصلك بالشخص المناسب',
  slogan_ai: 'الذكاء الاصطناعي الذي يفهمك ويوصلك بالشخص المناسب',
  get_the_app: 'احصل على التطبيق',
  desc_iphone_ipad: 'iPhone / iPad',
  desc_android: 'Android',
  search_in_app_stores: 'أو ابحث عن OctoSay في متاجر التطبيقات',

  // MapLocationPicker.vue
  placeholder_search_location: 'ابحث عن موقع...',
  coords_display: 'خط الطول: {lng}، خط العرض: {lat}',
  toast_no_geolocation: 'متصفحك لا يدعم تحديد الموقع الجغرافي',
  toast_location_permission_denied: 'تعذر الحصول على موقعك، يرجى التحقق من أذونات الموقع',
  loading_address: 'جارٍ تحميل العنوان...',

  // MatchedSession.vue
  created_at: 'أُنشئ: {time}',
  ai_match_analysis: 'تحليل المطابقة من AI',
  error_missing_session_params: 'معلمات الجلسة المطلوبة مفقودة',
  match_private_hint: 'هذه الجلسة خاصة. المحتوى غير متاح',

  // PersonalCenter.vue
  label_name: 'الاسم:',
  placeholder_enter_name: 'أدخل اسمك',
  label_bio: 'نبذة:',
  placeholder_enter_bio: 'اكتب شيئاً عن نفسك',
  placeholder_bio_empty: 'قل شيئاً عن نفسك',
  bio: 'نبذة',
  delete_account: 'حذف الحساب',
  delete_warning: 'لا يمكن التراجع عن هذا الإجراء.',
  delete_data_intro: 'سيتم حذف البيانات التالية نهائياً:',
  delete_item_profile: 'معلومات ملفك الشخصي',
  delete_item_chat: 'سجل المحادثات والجلسات',
  delete_item_contact: 'معلومات جهات الاتصال',
  delete_item_all: 'جميع البيانات المرتبطة',
  final_confirmation: 'التأكيد النهائي',
  delete_confirm_prompt: 'اكتب "delete" للتأكيد:',
  placeholder_type_delete: 'اكتب delete',
  private_token: 'الرمز الخاص',
  token_desc: 'أنشئ رمزاً للوصول إلى واجهة API',
  toast_not_logged_in: 'المستخدم غير مسجل الدخول',
  toast_name_required: 'الاسم مطلوب',
  toast_save_success: 'تم الحفظ بنجاح',
  toast_save_failed: 'فشل الحفظ',
  toast_image_too_large: 'الصورة تتجاوز حد 5MB',
  toast_avatar_updated: 'تم تحديث الصورة الشخصية',
  toast_avatar_failed: 'فشل تحديث الصورة الشخصية',
  toast_upload_failed: 'فشل الرفع',
  toast_token_generated: 'تم إنشاء الرمز',
  toast_token_failed: 'فشل إنشاء الرمز',
  toast_copied: 'تم النسخ إلى الحافظة',
  toast_copy_failed: 'فشل النسخ',
  toast_account_deleted: 'تم حذف الحساب بنجاح',
  toast_delete_account_failed: 'فشل حذف الحساب',
  toast_logout_success: 'تم تسجيل الخروج بنجاح',
  toast_logout_failed: 'فشل تسجيل الخروج',
  profile_tab_messages: 'الرسائل',
  profile_tab_comments: 'التعليقات',
  profile_tab_likes: 'الإعجابات',
  profile_tab_bookmarks: 'المحفوظات',
  profile_empty_messages: 'لا توجد رسائل بعد',
  profile_empty_comments: 'لا توجد تعليقات بعد',
  profile_empty_likes: 'لا توجد إعجابات بعد',
  profile_empty_bookmarks: 'لا توجد محفوظات بعد',
  profile_reply_to: 'رد على {name}',
  profile_stats_posts: 'الرسائل',
  profile_stats_comments: 'التعليقات',
  profile_stats_likes: 'الإعجابات المستلمة',
  profile_joined: 'انضم {date}',

  // ReportDialog.vue
  report_message_title: 'الإبلاغ عن رسالة',
  report_reason_prompt: 'يرجى اختيار سبب الإبلاغ عن هذه الرسالة:',
  report_spam: 'بريد مزعج',
  report_harassment: 'مضايقة أو تنمر',
  report_inappropriate: 'محتوى غير لائق',
  report_other: 'أخرى',
  placeholder_report_desc: 'صف المشكلة (اختياري)',
  toast_select_reason: 'يرجى اختيار سبب',
  toast_report_success: 'تم إرسال الإبلاغ بنجاح',
  toast_report_failed: 'فشل إرسال الإبلاغ',

  // common.js
  ellipsis: '..',

  // ChatBox.vue / ChatMsgList.vue message summary prefixes
  summary_image: '[صورة]',
  summary_images: '[صور×{count}]',
  summary_file: '[ملف]',
  summary_files: '[ملفات×{count}]',
  summary_video: '[فيديو]',
  summary_videos: '[فيديوهات×{count}]',
  summary_location: '[موقع]',
  summary_locations: '[مواقع×{count}]',
  summary_emoji: '[رمز تعبيري]',
  summary_emojis: '[رموز×{count}]',
  summary_voice: '[صوت]',
  summary_voices: '[أصوات×{count}]',
  summary_mixed: '[مختلط]',
  summary_other: '[أخرى]',

  // Voice messages
  voice: 'صوت',
  voice_recording: 'جارٍ التسجيل...',
  toast_voice_too_short: 'التسجيل قصير جداً',
  toast_voice_failed: 'فشل إرسال الصوت',
  toast_mic_permission_denied: 'لا يمكن الوصول إلى الميكروفون. يرجى تفعيله في إعدادات المتصفح',
  toast_recording_not_supported: 'التسجيل الصوتي غير مدعوم في هذا المتصفح',
  voice_load_failed: 'فشل تحميل الرسالة الصوتية',

  // Expire At
  aiChat_expireLine: 'صالح حتى {date}، أخبر AI في أي وقت للتحديث',
  aiChat_expireExpired: "انتهت صلاحية المحتوى ولم يعد مرئياً للآخرين. أخبر AI في أي وقت لتحديث تاريخ الانتهاء",

  // MatchedSession.vue
  detail: 'تفاصيل',

  // Match notification hints
  match_new_result_hint: 'إذا ظهرت نتائج مطابقة جديدة لاحقاً، ستُبلَّغ عبر البريد الإلكتروني. للحصول على تجربة أفضل، ثبّت التطبيق لتلقي إشعارات فورية.',

  // Match notification hints
  match_connection_notify_hint: 'تمت المطابقة وإبلاغ الطرف الآخر! اذهب وحيِّه!',
  match_continuousMatching: "يواصل AI البحث عن التوافقات لك",
  match_continuousMatchingHint: 'سنخبرك فور العثور على مطابقات جديدة',
  match_continuousMatchingOthers: "يواصل AI البحث عن التوافقات لهم",
  match_continuousMatchingOthersHint: 'ستظهر المطابقات الجديدة هنا فور العثور عليها',
  match_noResultsTitleOthers: 'ما زلنا نبحث عن مطابقة لهم',
  match_noResultsHintOthers: "يواصل AI البحث عن التوافقات لهم باستمرار. ستظهر النتائج هنا فور العثور عليها.",
  match_newMatchFound: 'توافقات جديدة: {n}!',
  match_worth_exploring_hint: 'أنت من يقرر ما إذا كان سيتواصل.',

  // Matches filter tags
  filter_all: 'الكل',
  filter_best_connection: 'أفضل مطابقة',
  filter_worth_a_look: 'جديرة بالاطلاع',

  // LandingPage.vue (CN Portal)
  landing_brand_slogan: 'OctoSay - الذكاء الاصطناعي الذي يفهمك ويوصلك بالشخص المناسب',
  landing_hero_title: 'اكتب في الـhub — يوضح AI أولاً، ثم تنشر وتحصل على مطابقات.',
  landing_hero_subtitle: 'اكتب الرسالة التي تريد مشاركتها في مجموعة Octo. قبل نشرها، سيتحدث معك AI لضبط التفاصيل. بعد تأكيدك، تُنشر رسالتك وملخص الذكاء الاصطناعي معاً، ويبدأ AI في المطابقة.',
  landing_download_on: 'نزّله من',
  landing_get_it_on: 'احصل عليه من',
  landing_direct_download: 'تنزيل مباشر',
  landing_how_title: 'كيف يعمل',
  landing_step1_title: 'اكتب في المجموعة',
  landing_step1_desc: 'اكتب الرسالة التي تريد مشاركتها في الـhub. سيتحدث معك الذكاء الاصطناعي أولاً لتوضيح التفاصيل، فيصبح كل منشور واضحاً ومفيداً وجاهزاً للمطابقة — لا يضيع بين الضجيج.',
  landing_step2_title: 'أكّد وانشر واحصل على مطابقات',
  landing_step2_desc: 'عند التأكيد، تُنشر رسالتك الأصلية وملخص الذكاء الاصطناعي معاً في الـhub. ثم يواصل الذكاء الاصطناعي إيجاد أفضل المطابقات لك، فلا تُدفن رسالتك أو تُهمَل.',
  landing_step3_title: 'تواصل ودرّدش',
  landing_step3_desc: 'عند حدوث المطابقة، يستطيع الطرفان رؤية سجل محادثات كل منهما مع AI وملخص الذكاء الاصطناعي. بسياق مشترك، يصبح كسر الجليد سهلاً — دردشوا ببساطة بشكل طبيعي.',
  // Comparison Section
  landing_comparison_title: 'لماذا OctoSay؟',
  landing_comparison_subtitle: 'دردشة بأسلوب الـhub، لكن AI يوضح تفاصيلك ويطابقك بنشاط.',
  landing_comparison_other: 'Discord',
  landing_comparison_octo: 'OctoSay',
  landing_cmp1_label: 'جودة المحتوى',
  landing_cmp1_other: 'إغراق بالسبام والإعلانات والرسائل الخارج عن الموضوع',
  landing_cmp1_octo: 'بطاقات احتياجات منتقاة بالذكاء الاصطناعي فقط',
  landing_cmp2_label: 'إيجاد الأشخاص',
  landing_cmp2_other: 'انشر وانتظر الردود فقط',
  landing_cmp2_octo: 'AI يطابقك بنشاط',
  landing_cmp3_label: 'مستوى الضجيج',
  landing_cmp3_other: 'مئات الرسائل للتمرير',
  landing_cmp3_octo: 'ضجيج صفري، لكل منشور قيمة',
  landing_cmp4_label: 'للبدء',
  landing_cmp4_other: 'ابحث عن خادم، تصفح القنوات، تعلم بنفسك',
  landing_cmp4_octo: 'اكتب في الـhub؛ AI يوضح ويطابق',
  landing_cmp_other_wechat: 'WeChat',
  landing_cmp_other_xhs: 'Xiaohongshu',
  landing_cmp_other_facebook: 'Facebook',
  landing_cmp_other_reddit: 'Reddit',
  landing_cmp1_wechat: 'محادثات جماعية مغمورة بالإعلانات والسبام',
  landing_cmp1_xhs: 'منشورات دعائية في كل مكان، يصعب الوثوق بها',
  landing_cmp1_facebook: 'الإعلانات والعناوين المضللة تغمر ملفك',
  landing_cmp1_reddit: 'سبام ومنشورات خارج الموضوع في كل مكان',
  landing_cmp2_wechat: 'فقط عبر جهات الاتصال ودعوات المجموعات',
  landing_cmp2_xhs: 'ابحث بنفسك وتنقيب في المنشورات',
  landing_cmp2_facebook: 'مقتصر على أصدقائك ومجموعاتك الحالية',
  landing_cmp2_reddit: 'تصفح المجتمعات بنفسك وانتظر الردود',
  landing_cmp3_wechat: 'التمرير عبر مئات رسائل المجموعة',
  landing_cmp3_xhs: 'ملفك ممتلئ بالتوصيات والإعلانات',
  landing_cmp3_facebook: 'منشورات موصى بها وإعلانات لا تنتهي',
  landing_cmp3_reddit: 'مئات التعليقات للتمرير',
  landing_cmp5_label: 'من يبحث',
  landing_cmp5_wechat: 'اسأل واحداً واحداً واترك الأمر للحظ',
  landing_cmp5_xhs: 'انشر، انتظر التعليقات، وصفِّ بنفسك',
  landing_cmp5_facebook: 'عليك أن تسأل هنا وهناك في المجموعات',
  landing_cmp5_reddit: 'انشر، انتظر الردود، ثم صفِّ',
  landing_cmp5_octo: 'الذكاء الاصطناعي يبحث لك عن الأشخاص باستمرار، تلقائياً',

  landing_features_title: 'الميزات الرئيسية',
  landing_feature1_title: 'وضّح قبل النشر',
  landing_feature1_desc: 'لا نماذج لتعبئتها. اكتب رسالتك في الـhub وسيحدثك AI أولاً ليطرح الأسئلة الصحيحة ويفهم احتياجاتك حقاً.',
  landing_feature2_title: 'نظيف، لا فوضوي',
  landing_feature2_desc: 'تُنشر رسالتك وملخص الذكاء الاصطناعي معاً — OctoSay ينقّي كل منشور، فلا سبام، ولا إغراق خارج الموضوع، ولا ضجيج للتمرير.',
  landing_feature3_title: 'مطابقة استباقية',
  landing_feature3_desc: 'بعد تأكيدك ونشر رسالتك وملخص الذكاء الاصطناعي، يمسح AI الـhub باستمرار ليجد الأشخاص المناسبين لما تبحث عنه — ويشرح السبب.',
  landing_feature4_title: 'مجتمعات حسب الموضوع، ضجيج صفري',
  landing_feature4_desc: 'انضم إلى مجموعات حسب الموضوع — رياضة، ألعاب، تبادل لغوي، شريك سكن — يوضح AI رسالتك قبل النشر، فيبقى كل مجموعة نظيفاً ومفيداً.',
  landing_feature5_title: 'خصوصية محمية',
  landing_feature5_desc: 'يمكنك جعل الرسائل خاصة بعد إرسالها، مرئية لك وحدك. تحكم كامل.',
  landing_feature6_title: 'محادثات ذات معنى',
  landing_feature6_desc: 'بلا ضجيج أو تشتيت — لكل رسالة قيمة.',
  landing_usecases_title: 'يعمل لأي سيناريو',
  landing_usecases_subtitle: 'أياً كان ما يدور في ذهنك، انضم إلى مجموعة حسب الموضوع — AI يتولى المطابقة فلا تحتاج إلى التمرير والبحث',
  landing_usecase_game: 'رفيق ألعاب',
  landing_usecase_language: 'تبادل لغوي',
  landing_usecase_skill: 'تبادل مهارات',
  landing_usecase_roommate: 'بحث عن شريك سكن',
  landing_usecase_travel: 'رفيق سفر',
  landing_usecase_sports: 'شريك رياضي',
  landing_usecase_study: 'شريك دراسة',
  landing_usecase_anything: '...أو شارك أي شيء',
  landing_cta_title: 'مستعد للبدء؟',
  landing_cta_desc: 'انضم إلى مجموعة حسب الموضوع، اكتب ما تريد مشاركته، دع AI يوضح التفاصيل، ثم انشر واحصل على مطابقات مع الأشخاص المناسبين.',
  landing_use_now: 'استخدمه الآن',
  landing_groups: 'المجموعات',

  // OnboardingPage.vue
  onboarding_skip: 'تخطي',
  onboarding_next: 'التالي',
  onboarding_getStarted: 'ابدأ',
  onboarding_step1Title: "قل ما تحتاجه في المجتمع",
  onboarding_step1Desc: "ما كنت تبحث عنه أو تريد فعله، قله ببساطة. سيتحدث معك الذكاء الاصطناعي لتوضيح التفاصيل ويحوّل كلامك إلى طلب واضح يفهمه الجميع.",
  onboarding_step2Title: 'أكّد وانشر واحصل على مطابقات',
  onboarding_step2Desc: "بمجرد نشر رسالتك في المجتمع، يجد الذكاء الاصطناعي باستمرار أفضل التوافقات لك، حتى لا تدفن رسالتك أو يتم تجاهلها.",
  onboarding_step3Title: 'تواصل ودرّدش',
  onboarding_step3Desc: "يمكن لكلا الطرفين رؤية ما دردش به الآخر مع AI ومعرفة ما يريده. ومع السياق المشترك، يصبح كسر الجليد سهلاً — فقط دردش بشكل طبيعي.",

  // ChannelDetail.vue
  channel_image_limit: 'صورة واحدة كحد أقصى',

  // ChannelMembers.vue
  channel_members_empty: 'لا يوجد أعضاء بعد',
  channel_members_title: 'الأعضاء',
  channel_role_owner: 'المالك',
  channel_role_admin: 'مشرف',
  channel_role_member: 'عضو',

  // Settings.vue
  settings_language: 'اللغة',
  settings_language_followSystem: 'حسب إعدادات النظام',

  // ChatBox.vue
  match_interested_suffix: '، {count} يستحقون النظر',

  // ChatBox.vue - مراحل تقدم المطابقة بالذكاء الاصطناعي
  match_stage_fetch_chat: 'جارٍ جلب المحادثة',
  match_stage_query_expansion: 'جارٍ توسيع الاستعلامات',
  match_stage_semantic_search: 'البحث الدلالي',
  match_stage_deep_search: 'تحليل عميق',
  match_stage_rerank: 'مطابقة ذكية',
  match_stage_refining: 'جارٍ تحسين النتائج',
  match_stage_fetch_details: 'جارٍ جلب التفاصيل',

  // ChannelDetail.vue - رفع الصور
  channel_select_image: 'يرجى اختيار ملف صورة',
  channel_image_upload_failed: 'فشل رفع الصورة، يرجى المحاولة مرة أخرى',
  chatInput_channelSearchHint: "ابحث عن مجتمع",
}



// WEBPACK FOOTER //
// ./src/i18n/ar.js